import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Stack, Typography, useMediaQuery } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { eventList, glb_sv, sendRequest, serviceList, socket_sv } from 'src/utils';
import crypt from 'src/utils/service/crypt';
import Loader from '../loader/loader';
import moment from 'moment';
import { getGeoLocation } from 'src/hooks/useGetLocation';
import { getPublicIP } from 'src/hooks/useIpWan';
import { generateMixedId } from 'src/utils/formatNumber';

const getCurrentDateTime = () => {
    const now = new Date();
    console.log('now time: ', now);

    // Tính giờ VN = giờ UTC + 7
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const vnTime = new Date(utc + 7 * 60 * 60 * 1000);

    const year = vnTime.getFullYear();
    const month = ('0' + (vnTime.getMonth() + 1)).slice(-2);
    const day = ('0' + vnTime.getDate()).slice(-2);
    const hours = ('0' + vnTime.getHours()).slice(-2);
    const minutes = ('0' + vnTime.getMinutes()).slice(-2);
    const seconds = ('0' + vnTime.getSeconds()).slice(-2);

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
};

async function getVNTimeFromServer() {
    return getCurrentDateTime();
    try {
        const response = await fetch('https://worldtimeapi.org/api/timezone/Asia/Ho_Chi_Minh');
        if (!response.ok) {
            return getCurrentDateTime();
        }

        const data = await response.json();
        const datetime = data.datetime; // VD: "2025-07-10T15:42:30.123456+07:00"

        // Cắt chuỗi thành định dạng bạn cần
        const date = new Date(datetime);
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);

        return `${year}${month}${day}${hours}${minutes}${seconds}`; // "20250710154230"
    } catch (error) {
        console.error('Lỗi khi lấy giờ từ server:', error);
        return getCurrentDateTime();
    }
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const LoginHikvisionModal = ({ visible = false, dataUpdate, setVisible, fuctGet, infoSession, setInfoSession }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const loginRef = useRef(false);
    const [flag, setFlag] = useState(false);
    const navigate = useNavigate();

    const countNumber = useRef(0);
    const interval = useRef();

    const [loading, setLoading] = useState(false);
    const cabinetData = useRef(glb_sv.getLocalStorageCabinet('cabinet') || {});

    const currentTime = useRef();
    const [timelogin, setTimelogin] = useState(currentTime.current);

    const [elapsedTime, setElapsedTime] = useState(0);
    const [canClose, setCanClose] = useState(true);
    const [socketSendUser, setSocketSendUser] = useState({
        id: '',
        name: '',
    });

    useEffect(() => {
        cabinetData.current = glb_sv.getLocalStorageCabinetLogin('cabinet');
        console.log('cabinetData.current', cabinetData.current);
    }, []);

    useEffect(() => {
        if (canClose) {
            return () => {
                handleClose(); // sẽ gọi khi component unmount (ví dụ tắt web/tab)
            };
        }
    }, [canClose]);

    const fetchInfo = async () => {
        let data = { latitude: 0, longitude: 0 };
        let ipWanData = '';

        try {
            data = localStorage.getItem('geo_location');
            if (!data) {
                data = await getGeoLocation();
                localStorage.setItem('geo_location', JSON.stringify(data));
            } else {
                data = JSON.parse(data);
            }
        } catch (err) {
            console.warn('Geo location failed', err);
        }
        try {
            ipWanData = await getPublicIP();
        } catch (err) {
            console.warn('IP fetch failed', err);
        }

        let deviceId = localStorage.getItem('device_id');
        if (!deviceId) {
            deviceId = generateMixedId();
            localStorage.setItem('device_id', deviceId);
        }

        setInfoSession({
            deviceId: deviceId,
            ipWan: ipWanData,
            latitude: data.latitude,
            longitude: data.longitude,
        });
        return {
            deviceId: deviceId,
            ipWan: ipWanData,
            latitude: data.latitude,
            longitude: data.longitude,
        };
    };
    // useEffect(() => {
    //     fetchInfo();
    // }, [infoSession]);

    useEffect(() => {
        const start = async (infoSession2) => {
            if (visible && countNumber.current < 15) {
                const time = await getVNTimeFromServer();

                console.log('getCurrentDateTime', getCurrentDateTime());
                console.log('Giờ Việt Nam chính xác:', time);
                currentTime.current = time;
                setTimelogin(time);
                // });
                let infoSessionCheck = infoSession2;
                console.log(infoSessionCheck);
                if (
                    // infoSession?.latitude == 0 ||
                    // infoSession?.longitude == 0 ||
                    infoSession?.ipWan == '' ||
                    infoSession?.deviceId == ''
                ) {
                    infoSessionCheck = await fetchInfo();
                }

                loginHikvision(time, infoSessionCheck);
                interval.current = setInterval(() => {
                    //     loginHikvision();
                    countNumber.current += 1;
                    setElapsedTime((prevTime) => prevTime + 1);

                    if (countNumber.current >= 15) {
                        clearInterval(interval.current); // Dừng interval nếu countNumber >= 5
                    }
                }, 1000);
            } else {
                interval.current && clearInterval(interval.current);
                countNumber.current = 0;
                setElapsedTime(0);
            }
        };
        start(infoSession);
    }, [visible]);

    const loginHikvision = (time, infoSessionD) => {
        setCanClose(true);
        if (loginRef.current) return;
        if (!cabinetData.current) {
            toast.error('Error: ' + t('err_login_hik'));
            setVisible(false);
            return;
        }
        loginRef.current = true;
        setFlag(true);
        const Inval = [time, cabinetData.current.id, JSON.stringify(infoSessionD)];
        sendRequest(serviceList.loginHikvision, Inval, loginHikvisionResult, true, timeOutFunctLoginHikvision, 20000);
    };

    useEffect(() => {
        glb_sv.commonEvent.subscribe((msg) => {
            const message = msg.data;

            if (message['proc_code'] === 'AUT007' && loginRef.current == true && flag == true) {
                toast.error('Error: ' + message['proc_message'], { autoClose: 1500 });
                setLoading(true);
                loginRef.current = false;
                setFlag(false);
                setTimeout(() => {
                    interval.current && clearInterval(interval.current);
                    handleClose();
                }, 1000);
                return;
            }
            if (message?.proc_data?.transition === 'send_socket') {
                setSocketSendUser({
                    id: message?.proc_data.rows[0]?.o_1,
                    name: message?.proc_data.rows[0]?.o_2,
                });
            } else if (msg.type === eventList.LOGIN_HIKVISION && loginRef.current == true && flag == true) {
                if (message) {
                    loginRef.current = false;
                    setFlag(false);
                    const data = message.proc_data.rows[0]?.o_1;
                    const menu = message.proc_data.rows[0]?.o_2;

                    // console.log('data', data);
                    // console.log('menu', menu);
                        
                    if (data && menu) {
                        const enCode = crypt.enCode(JSON.stringify(data));
                        const enCodeMenu = crypt.enCode(
                            JSON.stringify([
                                ...menu,
                                {
                                    navigate: '/home/category/',
                                    screens: 'Giỏ hàng',
                                    screens_key: 'gio_hang',
                                    user_id: 0,
                                    permiss_screen: {},
                                    company_id: 100,
                                    id: 100,
                                    department_id: 100,
                                    icons: 'material-symbols:shopping-cart',
                                },
                            ])
                        );
                        sessionStorage.setItem('proc_data', enCode);
                        sessionStorage.setItem('menu', enCodeMenu);
                        glb_sv.sessionInfo.comp_id = data.o_3;
                        glb_sv.sessionInfo.branch_id = data.o_4;
                        glb_sv.sessionInfo.user_id = data.id;

                        glb_sv.userInfo = data;
                        glb_sv.menu = menu;

                        toast.success(t('login_success'));

                        interval.current && clearInterval(interval.current);
                        loginIOT();
                        setLoading(true);
                         // Request fullscreen directly on Hikvision login success if not already fullscreen
                         const isCurrentlyFS = !!(
                             document.fullscreenElement ||
                             document.mozFullScreenElement ||
                             document.webkitFullscreenElement ||
                             document.msFullscreenElement
                         );
                         if (!isCurrentlyFS) {
                             const docEl = document.documentElement;
                             const requestFullScreen =
                                 docEl.requestFullscreen ||
                                 docEl.mozRequestFullScreen ||
                                 docEl.webkitRequestFullscreen ||
                                 docEl.msRequestFullscreen;
                             if (requestFullScreen) {
                                 requestFullScreen.call(docEl).catch(err => {
                                     console.log('Failed to enter fullscreen on Hikvision login:', err);
                                 });
                             }
                         }

                         // setTimeout(() => {
                         setVisible(false);
                         setLoading(false);
                         // }, 1000);
                         navigate('/home', { replace: true });
                    }
                }
            }
        });
    }, [flag, loginRef, socketSendUser]);

    useEffect(() => {
        if (countNumber.current === 15) {
            setLoading(true);
            toast.error(t('login_fail'), { autoClose: 1500 });
            setTimeout(() => {
                handleClose();
            }, 1000);
        }
    }, [countNumber.current]);

    const loginHikvisionResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            loginRef.current = false;
            setFlag(false);
            // console.log("False", countNumber.current, message);
            if (message['proc_code'] === 'AUT002' || message['proc_code'] === 'AUT003') {
                toast.error('Error: ' + message['proc_message'], { autoClose: 1500 });
                setLoading(true);
                setTimeout(() => {
                    interval.current && clearInterval(interval.current);
                    handleClose();
                }, 1000);
                return;
            }
            if (message['proc_code'] === 'AUT005') {
                toast.error('Error: ' + message['proc_message'], { autoClose: 1500 });
                setLoading(true);
                setTimeout(() => {
                    interval.current && clearInterval(interval.current);
                    handleClose();
                }, 1000);
                return;
            }
            if (message['proc_code'] === 'AUT006') {
                toast.error('Error: ' + message['proc_message'], { autoClose: 1500 });
                setLoading(true);
                setTimeout(() => {
                    interval.current && clearInterval(interval.current);
                    setVisible(false);
                    setLoading(false);
                    loginRef.current = false;
                    setFlag(false);
                }, 1000);

                setCanClose(false);
                return;
            }
            if (countNumber.current === 15) {
                toast.error('Error: ' + message['proc_message'], { autoClose: 1000 });
                // setCountdown(10);
                setLoading(true);
                setTimeout(() => {
                    handleClose();
                }, 1000);
                return;
            }

            toast.error('Error: ' + message['proc_message'], { autoClose: 1000 });
            // setCountdown(10);
            setLoading(true);
            setTimeout(() => {
                handleClose();
            }, 1000);
        } else {
            // console.log("Login Success")
            const data = message.proc_data.rows;
            const transition = message?.proc_data?.transition;
            // console.log('data', data);
            // console.log('menu', menu);
            if (data == 'login_hik' || transition === 'send_socket') {
                //     const enCode = crypt.enCode(JSON.stringify(data));
                //     const enCodeMenu = crypt.enCode(
                //         JSON.stringify([
                //             ...menu,
                //             {
                //                 navigate: '/home/category/',
                //                 screens: 'Giỏ hàng',
                //                 screens_key: 'gio_hang',
                //                 user_id: 0,
                //                 permiss_screen: {},
                //                 company_id: 100,
                //                 id: 100,
                //                 department_id: 100,
                //                 icons: 'material-symbols:shopping-cart',
                //             },
                //         ])
                //     );
                //     sessionStorage.setItem('proc_data', enCode);
                //     sessionStorage.setItem('menu', enCodeMenu);
                //     glb_sv.sessionInfo.comp_id = data.o_3;
                //     glb_sv.sessionInfo.branch_id = data.o_4;
                //     glb_sv.sessionInfo.user_id = data.id;
                //     glb_sv.userInfo = data;
                //     glb_sv.menu = menu;
                //     toast.success(t('login_success'));
                //     interval.current && clearInterval(interval.current);
                //     loginIOT();
                //     setLoading(true);
                //     // setTimeout(() => {
                //     setVisible(false);
                //     setLoading(false);
                //     // }, 1000);
                //     navigate('/home', { replace: true });
            } else {
                loginRef.current = false;
                setFlag(false);
                toast.error(t('system_reject_login'));
                if (countNumber.current === 15) {
                    toast.error('Error: ' + message['proc_message'], { autoClose: 1000 });
                    // setCountdown(10);
                    setLoading(true);
                    setTimeout(() => {
                        handleClose();
                    }, 1000);
                }
            }
        }
    };

    const timeOutFunctLoginHikvision = (reqInfo) => {
        setFlag(false);
        loginRef.current = false;
        toast.error(t('error.time_out') + ' Hikvision');
        setVisible(false);
    };

    const handleClose = () => {
        interval.current && clearInterval(interval.current);
        setVisible(false);
        setLoading(false);
        loginRef.current = false;
        setFlag(false);
        setSocketSendUser({
            id: '',
            name: '',
        });
        closeHik();
    };

    const closeHik = () => {
        const chooseCabinetLocal = cabinetData.current;
        const service = serviceList.closeHik;
        const inpuVal = [chooseCabinetLocal?.id];
        sendRequest(service, inpuVal, CloseHikResult, true, timeOutFunctIOT, 40000);
    };
    const CloseHikResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            // toast.success('Error: ' + message['proc_message']);
        }
    };

    const loginIOT = () => {
        const cabinet_cd = glb_sv.getLocalStorageCabinet('cabinet');
        sendRequest(
            serviceList.loginIOT,
            [cabinet_cd?.cabinet_cd || ''],
            loginIOTResult,
            true,
            timeOutFunctIOT,
            40000,
            0
        );
    };
    const loginIOTResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            toast.success('Error: ' + message['proc_message']);
        }
    };
    const timeOutFunctIOT = (e) => {
        toast.error(t('error.time_out') + ' IOT');
    };
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
        >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                <Box
                    sx={{
                        display: 'flex',
                        direction: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 1,
                    }}
                >
                    <Typography variant="h4" align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {t('login_hik')}
                    </Typography>
                    <Typography
                        variant="h6"
                        align="center"
                        sx={{ whiteSpace: 'nowrap', marginRight: '30px', fontWeight: '100' }}
                    >
                        {moment(timelogin, 'YYYYMMDDHHmmss').format('HH:mm:ss')}
                        {/* {'->'}
                        {moment(timelogin, 'YYYYMMDDHHmmss').add(15, 'seconds').format('HH:mm:ss')} */}
                    </Typography>
                </Box>
            </BootstrapDialogTitle>
            <Loader loading={loading} />
            <DialogContent dividers>
                <Stack sx={{ alignItems: 'center' }}>
                    <Typography variant="h3" align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {t('cabinet')} {cabinetData.current?.cabinet_nm}
                    </Typography>
                    <Typography variant="h6" align="center" sx={{ px: 5, mb: 2, width: '100%' }}>
                        {t('login_message')}
                    </Typography>
                    {socketSendUser?.name && (
                        <Typography
                            variant="h5"
                            align="center"
                            sx={{ px: 5, mb: 2, width: '100%', color: 'blue', whiteSpace: 'pre-line' }}
                        >
                            {t('staff')} {socketSendUser?.name || ''} {t('is_logining')}
                        </Typography>
                    )}

                    <CountdownCircleTimer
                        isPlaying
                        duration={15}
                        colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                        colorsTime={[10, 6, 3, 0]}
                        sx={{ mt: 2 }}
                    >
                        {() => (
                            <div className="timer">
                                <Typography className="value" variant="h2" align="center" sx={{ px: 5 }}>
                                    {elapsedTime}
                                </Typography>
                            </div>
                        )}
                        {/* {({ remainingTime }) => {
                            const displayTime = remainingTime;
                            return (
                                <div className="timer">
                                    <Typography className="value" variant="h2" align="center" sx={{ px: 5 }}>
                                        {displayTime}
                                    </Typography>
                                </div>
                            );
                        }} */}
                    </CountdownCircleTimer>
                    {socketSendUser?.name && (
                        <Typography
                            variant="h5"
                            align="center"
                            sx={{ px: 5, mb: 2, width: '100%', color: 'blue', whiteSpace: 'pre-line' }}
                        >
                            {t('is_processing')} ...
                        </Typography>
                    )}
                </Stack>
            </DialogContent>
        </BootstrapDialog>
    );
};

export default LoginHikvisionModal;
